import { option } from "framer-motion/client";
import AmBest from "../Components/AmBest/AmBest";

const TransEn = {
  navbar: {
    home: "Home",
    aboutus: "About Us",
    product: "Products",
    productSub: {
      universalLifeInsurance: "Universal Life Insurance",
      indexedUniversal: (
        <>
          Indexed Universal
          <br /> Life Insurance
        </>
      ),
      termLifeInsurance: (
        <>
          Term Life
          <br />
          Insurance
        </>
      ),
      criticalIllnessInsurance: (
        <>
          Critical Illness
          <br /> Insurance
        </>
      ),
      compareProduct: "Compare products",
      compareDesc:
        "Discover the main differences of our portfolio of life products.",
    },
    agents: "Agents",
    contactUs: "Contact Us",
    faqs: "FAQs",
    compareProducts: "Compare Products",
    universalLife: "Universal Life Insurance",
    indexedUniversalLife: "Indexed Universal Life Insurance",
    termLife: "Term Life Insurance",
    criticalIllness: "Critical Illness Insurance",
  },
  footer: {
    address: (
      <>
        American Fidelity International Ltd. (AFIL)
        <br /> The Grove, 21 Pine Rd, Belleville <br />
        Saint Michael, BB11113, Barbados
      </>
    ),
    number: "Telephone: 1 (246) 367-8874",
    email: "life-service@americanfidelity.com",
    fax: "Fax: (441) 292-0665",
    navLinks: {
      Home: "Home",
      About_Us: "About Us",
      Products: "Products",
      FAQs: "FAQs",
      American_Fidelity: "American Fidelity",
      Learn_More: "Learn More",
      AFIBL: "AFIL",
      Superior_Plan: "Superior Plan",
      Universal_Life: "Universal Life",
      Benefits: "Benefits",
      How_It_Works: "How it works",
      Indexed_Universal_Life: "Indexed Universal Life",
      Optima_Plan: "Optima Plan",
      Select_Term: "Select Term",
      Vital_Plan: "Vital Plan",
      Critical_Illness: "Critical Illness",
      AdditionalBenefits: "Additional Benefits",
      CoverageType: "Types of Coverage",
      ContactUs: "Contact Us",
    },
  },
  // WhyChoose HealthInsuranceHero.js
  provenExperience: "Proven Experience",
  provenExperienceDescription:
    "Insuring lives in the market for more than 20 years⁸.",
  flexibleProducts: "Flexible Products",
  flexibleProductsDescription:
    "Life insurance adapted to changing needs throughout life.",
  lastingCommitment: "Lasting Commitment",
  lastingCommitmentDescription:
    "We are committed to accompanying you over time, offering periodic reviews of your policy.",
  prestige: "Prestige",
  PrestigeDescription:
    "We are backed by a respected reputation in the international market. We strive to maintain the highest standards and offer first-class service to our customers.",
  WhyChooseHeading: "Why purchase Life<br />Insurance with us?",
  WhyChooseDescription:
    "When you choose your life insurance with us, you can expect stability, adaptability and long-term commitment.",

  // Faqs left content
  faqsLefttitle: "Questions? Answers",
  faqsLeftHeading: "Frequently Asked Questions",
  faqsLeftDescription:
    "We answer the main doubts that may arise when purchasing life insurance.",
  faqsLeftButton: "Contact Us",

  // Our Credential content
  ourCredentialHeading: "American Fidelity Assurance Company's Credentials",

  historyTab: "History",
  historyTitle: "Leader in the insurance industry for more than 62 years.",
  historyDescription:
    "American Fidelity International Ltd. is a member of the American Fidelity family of companies® along with its affiliate American Fidelity Assurance Company, a leading organization in the insurance industry for over 62 years.",
  historyLearnMore: "Learn more",

  cultureTab: "Culture",
  cultureFeatureOne: "Certified Great Place to work<sup>3</sup> (2024-2025)",
  cultureFeatureTwo:
    "Fortune Best Workplaces for Millennials <sup>(TM)</sup> 2024<sup>4</sup>",
  cultureFeatureThree:
    "Fortune Best Workplaces in Finance and Insurance 2024<sup>5</sup>",
  cultureFeatureFour:
    "Computerworld's Best Places to Work in IT 2024<sup>6</sup>",
  cultureFeatureFive: "PEOPLE Magazine Companies that Care 2021<sup>7</sup>",

  // Our Products Content
  ourProductHeading: "Our Products",

  universalLifeTab: "Universal Life",
  universalLifeHeading: "Financial protection for life",
  universalLifeDescriptionBold: "Financial protection for life.",
  universalLifeDescription:
    "An AFIBL universal life insurance policy combines two important elements: protection and savings.",

  termLifeTab: "Term Life",
  termLifeHeading:
    "A competitive product that may help guarantee the protection of your loved ones",
  termLifeDescriptionBold:
    "A competitive product that may help guarantee the protection of your loved ones.",
  termLifeDescription:
    "Term life insurance may help you financially protect your loved ones in the event of your death.",

  criticalIllnessTab: "Critical Illness",
  criticalIllnessHeading: "Protection against Critical Illness",
  criticalIllnessDescription:
    "Protection to Help with Critical Illness Costs. Critical illness insurance may help provide protection to help with Critical Illness costs.",
  productMoreButton: "More",
  productCompareButton: "Compare Plans",

  // About Us Banner
  aboutUsBannerTitle: "Commitment to Excellence and Leadership",
  aboutUsBannerDescription:
    "American Fidelity International Ltd. expands its life and health insurance services for international clients, reinforcing its vision of protection for Latin American clients.",
  aboutUsBannerButton: "Scroll to Learn More",

  americanfidelityTitle: "American Fidelity Family of Companies",
  americanfidelityDescription:
    "Our fundamental pillars of <em>integrity, dedication, and excellence</em> are the foundation of everything we do.",
  americanfidelityDescription2:
    "American Fidelity Family of companies consists of numerous companies including American Fidelity Corporation (AFC). AFC, through its subsidiaries, provides financial services, insurance and HR support. American Fidelity Assurance Company (AFA) and American Fidelity International Ltd. are subsidiaries of AFC.",
  americanfidelityAmount: "*Amounts in USD (Dollar).",

  afaConsolidatedTextOne: "AFA consolidated liquidity in 2024 <sup>8</sup>",
  afaConsolidatedTextTwo:
    "AFC consolidated accumulated benefits paid to customers in 2024 <sup>8</sup>",
  afaConsolidatedTextThree: "AFC consolidated net income in 2024 <sup>8</sup>",

  //Values ​​that guide content
  valuesHeading: "Values ​​that guide us",
  valuesDescription:
    "American Fidelity's fundamental beliefs to our clients are to always be fair, financially secure, flexible, focused, and future-oriented.",
  valuesAMBestTab: "AM Best",
  AmBestTitle: "A+ (Superior) Financial Strength Rating",
  AmBestDescription1: `Since 1982, American Fidelity Assurance Company has continuously obtained the Rating of  “A+” (Superior) by AM Best<sup>1</sup>.`,
  AmBestDescription2:
    "AM Best, considered one of the nation’s leading insurance rating services, bases its ratings on an analysis of the financial condition and operating performance of insurance companies in such vital areas as: balance sheet strength, operating performance, business profile, and enterprise risk management.",
  valuesWardsTab: "Ward's",
  valuesWardsTitle: "2024 Life Health Ward's 50® Companies Award",
  valuesWardsDescription1:
    "American Fidelity Assurance Company has been named on the 2024 list of Ward's 50® top performing life-health insurance companies.",
  valuesWardsDescription2:
    "This honor recognizes 50 companies’ financial performance. Each company has passed all safety and consistency screens and achieved superior performance over the five years analyzed <sup>2</sup>.",

  valuesOtherRewardsTab: "Other Awards",

  //International Clients content
  internationalHeading: "International Clients",
  internationalDescription:
    "Since 2001, American Fidelity International Ltd. has achieved great success in helping to provide financial security solutions to international clients.",
  internationalPurposeTitle: "Purpose",
  internationalPurposeDesc1:
    "American Fidelity International Ltd.'s goals are based on two basic principles:",
  internationalPurposeDesc2:
    "1. To provide our international clients with quality products to help meet their financial needs.",
  internationalPurposeDesc3:
    "2. To help provide our international clients with financial protection solutions.",

  // Product Compare Content
  productCompareHeading: "Products Comparison",
  productCompareDescription:
    "Discover the main differences of our portfolio of life products.",

  termProductTitle: "Term",
  termProductDescription1:
    "Individuals and families who need competitive coverage for a limited period.",
  termProductDescription2:
    "It guarantees the payment of a pre-established death benefit to the insured's beneficiaries if the insured dies during the specified term.",

  universalProductTitle: "Universal (Prime + Ultra III)",
  universalProductDescription1:
    "People looking for flexibility in their insurance.",
  universalProductDescription2:
    "Those who wish to adjust premiums and death benefits.",
  universalProductDescription3:
    "Individuals interested in accumulating cash value.",

  indexaProProductTitle: "Indexa Pro IUL",
  indexaProProductDescription1:
    "For those looking for cash value growth potential based on the S&P 500.",
  indexaProProductDescription2:
    "Those who want a combination of long-term performance and life insurance.",
  indexaProProductDescription3:
    "It guarantees the payment of a pre-established death benefit to the insured's beneficiaries if the insured dies during the specified term.",

  criticalProductTitle: "Critical Illness",
  criticalProductDescription1:
    "A product, designed with a defined stipulated benefit amount. ",
  criticalProductDescription2:
    "It is activated at the critical moment of diagnosis of a serious illness (as described in the policy), providing financial support.",

  guaranteedPremium: "Guaranteed premium",
  cashValue: "Usable cash value",
  premiumFlexibility: "Flexibility in premiums and frequency",
  deathBenefit: "Adjustment in death benefit amount",
  loanDuration:
    "Duration of 10, 15, 20, 30, up to age 85 and up to age 100 years",
  permanentPolicy: "Opportunity to convert to permanent policy",
  interestCredit: "Interest crediting based on the S&P 500®",
  interestCreditDesc:
    "(which can increase and decrease due to normal market fluctuations)",
  duringTerms: "(During the term)",

  // Critical Page content
  criticalIllnessHeading: "Protection to Help with Critical Illness Costs",
  criticalIllnessDescription:
    "The critical illness benefit may help provide the insured with financial protection in the event they suffer from a serious or critical illness covered by the policy.",
  criticalIllnessTabDescriptionBold:
    "Protection to Help with Critical Illness Costs.",
  criticalIllnessTabDescription:
    "Critical illness insurance may help provide protection to help with Critical Illness costs.",

  whyChooseIllness: {
    titleBold: "Why should you consider the",
    titleRegular: "Critical Illness policy?",
    subtitle: "Critical Illness",
    description:
      "The benefit will be paid directly to you so you may use this benefit to help pay for expenses, such as:",
    reasons: {
      medicalDebts: "Medical debts not covered by traditional health insurance",
      lossOfIncome: "Loss of income or existing debts",
      educationCosts:
        "School or college costs and child care costs during recovery",
      rehabilitation:
        "Rehabilitation, personal care in the home of the insured or qualified nurse.",
    },
  },

  productOverview: {
    sectionTitle: "Critical Illness",
    heading: "Product overview",
    whyConsiderHeadingBold: "Why should you consider the",
    whyConsiderHeadingRegular: "Critical Illness policy?",

    features: {
      upto80: {
        title: "Up to 80 years",
        description: "Guaranteed renewability up to 80 years of age.",
      },
      activation90: {
        title: "Activation 90 days",
        description: "Waiting period of 90 days after the coverage date.",
      },
      flexibility: {
        title: "Flexibility of use",
        description: "Lump sum payment that can be used to cover any need.",
      },
      extensiveCoverage: {
        title: "Extensive Coverage",
        description: "From $100,000 to $500,000.",
      },
    },
  },

  criticalIllnessTab1: {
    heading: "Diseases, Conditions and Surgical Procedures covered",
    coveredFull: "100% Covered",
    coveredHalf: "25% Covered or Only Once",
  },

  coveredFull: {
    description:
      "American Fidelity International Ltd. Critical Illness Policy pays 100% of the maximum benefit amount for the following diseases, conditions and surgeries, as defined in the policy:",
    diseases: {
      alzheimers: "Alzheimer's Disease",
      aorticSurgery: "Aortic Surgery",
      blindness: "Blindness",
      cancer: "Cancer",
      heartAttack: "Heart Attack (Myocardial infarction)",
      multipleSclerosis: "Multiple Sclerosis",
      paralysis: "Paralysis",
      renalFailure: "Renal Failure",
      severeBurns: "Severe Burns",
      stroke: "Stroke",
      deafness: "Deafness",
      organTransplant: "Organ Transplant",
    },
  },
  coveredHalf: {
    description1:
      "American Fidelity International Ltd. Critical Illness Policy pays 25% of the maximum benefit amount only once for the following procedures, as defined in the policy:",
    procedures: {
      coronaryBypass: "Coronary Artery Bypass",
      heartValveSurgery: "Heart Valve Surgery",
      coronaryAngioplasty: "Coronary Angioplasty",
    },
    description2:
      "American Fidelity International Ltd. Critical Illness Policy pays 25% of the maximum benefit amount up to a maximum of $25,000 only once for:",
  },

  // Terms Life Content
  termsBannerHeading:
    "A competitive product that may help guarantee the protection of your loved ones.",
  termsBannerDescription:
    "Term life insurance may help provide you with protection with a payable fixed amount of money to your beneficiary if you die within the policy term and while the policy is still active.",

  select_term: "Select Term",
  main_benefits: "Main benefits",
  of_the_policy: "of the policy",
  guaranteed_premiums_title: "Guaranteed Premiums",
  guaranteed_premiums_desc:
    "Guarantee that policy premiums will not increase during the term period.",
  conversion_option_title: "Conversion Option",
  conversion_option_desc:
    "A term life insurance policy can be converted to a permanent life insurance policy.",
  acceleratedDeathBenefitTitle: "Accelerated Death Benefit",
  acceleratedDeathBenefitDesc:
    "Provides financial assistance in case you suffer from a terminal illness, as defined in the policy.",
  automaticBenefitRiderTitle: "Automatic Benefit Increase (ABI) Rider",
  automaticBenefitRiderDesc:
    "This rider automatically increases the policy benefit by 3% at the end of each year during the first 5 years of the policy. Once the 15% increase in the original death benefit is reached, the benefit remains level as long as the policy remains in force.",

  improve_protection: "Improve your protection",
  with_additional_benefits: "with Additional Benefit Options",

  waiver_premium_title: "Waiver of Premium Rider",
  waiver_premium_desc:
    "This rider refunds the premium in its entirety if the primary insured becomes totally disabled for at least 180 days, as defined in the rider.",

  accidental_death_title: "Accidental Death and Dismemberment Benefit Rider",
  accidental_death_desc:
    "This rider provides additional protection if death results from an accident or provides additional benefits in case of loss of vision or loss of limb, as defined in the rider.",

  return_premium_title: "Return of Premium Rider",
  return_premium_desc:
    "Refunds all Cumulative Premium paid less any benefits paid on the last day of the Term Period, provided the policy is still active. Available with the 30 Year Term, and Term to Age 85.",

  additional_insured_title: "Additional Insured Term Rider",
  additional_insured_desc:
    "This rider provides term coverage for your spouse, family members and/or business partners.",

  variousTypesheading: "Various types of coverage available",
  termsTable: {
    termType: "Term type",
    issueAge: "Issue age",
    minimumCovered: "Minimum to cover all insureds",
    minimumAmount: "Minimum Face Amount:",
    term10: "Term 10",
    term15: "Term 15",
    term20: "Term 20",
    term30: "Term 30",
    term85: "Term 85",
    term100: "Term 100",
    years18_75: "18 to 75 years",
    years18_70: "18 to 70 years",
    years18_49: "18 to 49 years",
    years50_65: "50 to 65 years",
    years50_55: "50 to 55 years",
    years50_80: "50 to 80 years",
    amount500: "$500,000",
    amount300: "$300,000",
    amount250: "$500,000",
  },

  // Indexa universal content
  indexaBannerSubtitle: "Indexa Pro IUL",
  indexaBannerHeading:
    "Credits interest based on the performance of an independent financial index (S&P 500®)",
  indexaBannerDescription:
    "Insurance that, unlike traditional universal life policies, can credit interest and has the potential to generate account values ​​in your policy for future needs.",

  title_how_indexa_works: "How does Indexa Pro IUL work?",
  how_indexa_worksDesc1:
    "When a premium payment is made, the premium expense charge is deducted and the remaining portion is credited to your account value.",
  how_indexa_worksDesc2: `<span class="md:font-semibold">
                      At the beginning of each month,
                    </span>
                    the account value is reduced by the monthly deductions.
                    <span class="md:font-semibold">
                      At the end of the month,
                    </span>
                    the account value in the Fixed Account is credited with
                    interest. The Indexed Account is credited with interest on the
                    Segment Anniversary.`,
  premiums_title: "Premiums",
  premiums_info:
    "(Minus the premium expense charge as shown on the policy schedule.)",
  interest_title: "Interest",
  monthly_deductions_title: "Monthly deductions",
  monthly_deductions_info:
    "May include an administrative fee, cost of insurance for the policy, front-end load, charge per $1,000 of specified amount, and rider charges.",
  other_deductions_title: "Other deductions",
  other_deductions_info:
    "(Including any partial surrenders and partial surrender charges.)",
  account_value: "Account Value",

  fixed_and_indexed_accounts: "Fixed account and indexed account",
  fixed_account_title: "Fixed Account",
  fixed_account_description:
    "The Fixed Account offers positive and constant growth thanks to its fixed interest rate.",
  fixed_account_benefits: "It might be right for you if you want:",
  fixed_account_stable_interest: "More stable interest rates",
  fixed_account_lower_risk: "Lower risk",

  indexed_account_title: "Indexed Account",
  indexed_account_description:
    "The Indexed Account offers the potential for greater growth in account value because it is linked to the performance of the S&P 500® index.",
  indexed_account_benefits: "It might be right for you if:",
  indexed_account_higher_growth:
    "You want greater potential for account value growth.",
  indexed_account_higher_risk: "You are comfortable with higher risk.",

  indexed_universal_product: "Indexed Universal Product",
  indexed_account_title2: `The Indexed Account <span class="font-semibold">has a<br class="inline lg:hidden" /> Ceiling, a Participation Rate,<br class="inline lg:hidden" /> and a Floor.</span>`,

  indexed_account_description2: `<span class="font-bold">The Cap Rate</span> places a limit on the interest rate that can be credited.  Therefore, you will <span class="font-bold">earn interest when the S&P 500® </span> performs positively but will never earn higher than the limit placed on the Indexed Accounts.`,

  participation_rate_description: `<span class="font-bold">The Participation Rate</span> 
                    dictates the amount of the increase in the index used to
                    calculate the indexed interest rate.`,

  floor_description: `<span class="font-bold">The Floor</span> helps protect
                    from market declines. The credited rate will never be
                    negative even if the S&P 500® has a negative return.`,

  indexaBenefits: {
    improve_protection: `<stong class="font-semibold">Improve your protection</stong> with
              Additional Benefit Options+`,
    discover_more:
      "Discover more information about indexed universal life insurance.",
    watch_video: "Watch video",
    benefitsOptions: {
      options1_title: "Waiver of Specified Amount Rider",
      options1_Desc: `This rider provides a specified amount to be applied as premium to your account value if you become totally disabled, as defined in the rider. <br /> <span class="text-[#A8A9AC] ">(LR230B)</span>`,
      options2_title: "Accidental Death and Dismemberment Benefit Rider",
      options2_Desc: `This rider provides additional protection if death results from an accident or provides additional benefits in case of loss of vision or loss of limb, as defined in the rider.<br /> <span class="text-[#A8A9AC]">(LR234B)</span>`,
      options3_title: "Level Term Insurance for Children Rider",
      options3_Desc: `This rider provides term coverage for each eligible child, as defined in the rider. <br />  <span class="text-[#A8A9AC] ">(LR231B)</span>`,
      options4_title: "Long Term Care Benefit Rider",
      options4_Desc: `This rider provides a monthly income if you become totally disabled, as defined in the rider. Additionally, a long term care benefit will be paid if you are chronically ill, as defined in the rider.<br /> <span class="text-[#A8A9AC]">(LR233B)</span>`,
      options5_title:
        "Additional Insured Term Rider/Level Term Insurance Rider",
      options5_Desc: `Provides temporary coverage for spouse, family members and/or business partners. <br /> <span class="text-[#A8A9AC]">(LR232B)</span>`,
    },
  },

  // Universal Page content
  universalBannerHeading: "Permanent life insurance combines two elements:",
  universalBannerDesc: "cash value and protection",

  universalBenefits: {
    improve_protection: `<stong class="font-semibold">Improve your protection</stong> with
              Additional Benefit Options`,
    benefitsOptions: {
      options1_title: "Waiver of Specified Amount Rider",
      options1_Desc: `This rider provides a specified amount to be applied as premium to your account value if you become totally disabled, as defined in the rider. <br /> <span class="text-[#A8A9AC] ">(LR154B)</span>`,
      options2_title: "Accidental Death and Dismemberment Benefit Rider",
      options2_Desc: `This rider provides additional protection if death results from an accident or provides additional benefits in case of loss of vision or loss of limb, as defined in the rider.<br /> <span class="text-[#A8A9AC]">(LR195B)</span>`,
      options3_title: "Level Term Insurance Rider",
      options3_Desc: `This rider provides temporary coverage for spouse, family members and/or business partners. <br />  <span class="text-[#A8A9AC] ">(LR232B)</span>`,
      options4_title: "Level Term Insurance for Children Rider",
      options4_Desc: `This rider provides term coverage for each eligible child, as defined in the rider.<br /> <span class="text-[#A8A9AC]">(LR121B)</span>`,
      options5_title:
        "Monthly Disability Income Rider with Long Term Care Benefit",
      options5_Desc: `This rider provides a monthly income if you become totally disabled, as defined in the rider. Additionally, a long term care benefit will be paid if you are chronically ill, as defined in the rider.<br /> <span class="text-[#A8A9AC]">(LR162B)</span>`,
    },
  },

  main_benefits_title: "Main benefits of our policy",
  adjustable_premiums: "Adjustable Premiums",
  build_cash_value: "Build Cash Value",
  adjustable_death_benefit: "Adjustable Death Benefit",

  universeProduct_subtitle: "Universal Products",
  universeProduct_heading: `<span class="font-semibold">Protection</span> plus cash value<br class="inline lg:hidden" /> within the same policy`,
  universeProtection_tab: "Protection",
  universeProtection_title: "Life insurance may help with:",
  universeProtection_desc: `Replacing income <br />
              Paying off mortgages and other debt
              <br />
              Paying for burial expenses
              <br />
              Funding college education for children
              <br />
              Paying for estate taxes`,

  universeCashValue_tab: "Cash Value",
  universeCash_title: "The cash value accumulation may be used for:",
  universeCash_desc: `Retirement supplement <br />
              Major purchases (home, business) <br />
              Emergency cash needs`,

  universal_types_title: "Two types of universal life insurance products",
  indexed_universal_life: "Indexed Universal Life Insurance",
  indexed_universal_life_desc: `Indexed universal life (IUL) insurance is a permanent life insurance policy that offers a death benefit and a cash value component.  The cash value account can earn interest by tracking a stock market index, such as the 
                      <span class="font-bold">
                        Standard & Poor’s® S&P 500® INDEX
                      </span> which can increase and decrease due to normal market value fluctuations.`,
  indexed_min_death_benefit: "Minimum death benefit amount required $250,000",
  indexed_issue_ages: "Issue ages: 18-80 years of age",
  indexed_learn_more: "Learn more about Indexa Pro",
  universal_life: "Universal Life Insurance",
  universal_life_desc:
    "A permanent life insurance policy that provides the benefit of cash value accumulation at competitive rates.",
  universal_min_death_benefit: "Minimum death benefit amount required $100,000",
  universal_issue_ages: "Issue ages: 1-80 years of age",
  universal_available_products: "Two products available:",
  universal_product_1: "Platinum Ultra III",
  universal_product_2: "Prime",

  // other pages title
  securePageTitle: "Secure Computing Practices",
  termsPageTitle: "Terms of Use",
  footnotesPageTitle: "Footnotes",
  privacyPageTitle: "Privacy Notice Effective January 2025",
};

export default TransEn;
